<template>
    <section id="pdf">
        <div class="columns mb-6 pt-0">
            <div class="column is-6 pt-0">
                <p class="is-size-5">
                    <span class="has-text-weight-bold"
                        >{{ $t('Sessions.player') }}:
                    </span>
                    <span
                        >{{ player.alias ? player.alias : player.username }}
                    </span>
                </p>
                <p class="is-size-5">
                    <span class="has-text-weight-bold"
                        >{{ $t('Sessions.project') }}:
                    </span>
                    <span>{{ reportInfo.projectName }} </span>
                </p>
            </div>

            <div class="column is-6 pt-0 has-text-right">
                <p class="is-size-5">
                    <span class="has-text-weight-bold"
                        >{{ $t('Sessions.game') }}:
                    </span>
                    <span>{{ reportInfo.gameName }} </span>
                </p>
                <p class="is-size-5">
                    <span class="has-text-weight-bold"
                        >{{ $t('Sessions.game_type') }}:
                    </span>
                    <span>{{ reportInfo.gameType }} </span>
                </p>
            </div>
        </div>
        <hr class="navbar-divider has-background-grey-lighter mt-2 mb-0" />
        <p
            class="
                is-size-5
                has-text-centered has-text-weight-bold
                is-uppercase
                pb-4
                has-background-very-light-pink
            "
        >
            {{ $t('Sessions.general_data') }}
        </p>
        <hr class="navbar-divider has-background-grey-lighter mt-0" />

        <nav class="level is-mobile pt-3">
            <div class="level-item has-text-centered">
                <session-end-resume-bubble
                    :title="$t('Sessions.ranking_position')"
                    :number="player.position"
                />
            </div>

            <div class="level-item has-text-centered">
                <session-end-resume-bubble
                    :title="$t('Sessions.score_achieved')"
                    :number="player.score"
                />
            </div>

            <div class="level-item has-text-centered">
                <session-end-resume-bubble
                    :title="$t('Sessions.question_hit_rate')"
                    :number="player.hitRate"
                />
            </div>
        </nav>

        <hr class="navbar-divider has-background-grey-lighter" />

        <table class="table general-data is-fullwidth is-narrow pb-3">
            <tbody>
                <tr>
                    <td>{{ $t('Sessions.game_date') }}</td>
                    <td class="has-text-weight-bold">
                        {{ player.playedDate }}
                    </td>
                    <td>{{ $t('Sessions.game_time') }}</td>
                    <td class="has-text-weight-bold">
                        {{ player.gameTime }}
                    </td>
                </tr>
                <tr>
                    <td>{{ $t('Sessions.game_device') }}</td>
                    <td class="has-text-weight-bold">
                        {{ player.device }}
                    </td>
                    <td>
                        {{ $t('Sessions.game_time_per_answer') }}
                    </td>
                    <td class="has-text-weight-bold">
                        {{ player.meanTime }}
                    </td>
                </tr>
            </tbody>
        </table>

        <hr class="navbar-divider has-background-grey-lighter mb-0" />
    </section>
</template>

<script>
import SessionEndResumeBubble from '@/components/SessionEndResumeBubble';

export default {
    name: 'SessionDetailPlayerGeneralPDF',
    components: {
        SessionEndResumeBubble,
    },
    props: {
        player: {
            type: Object,
            default: () => {
                return {};
            },
        },
        reportInfo: {
            type: Object,
            default: () => {
                return {};
            },
        },
    },
};
</script>

<style scoped>
.table tr:not(.is-bordered-bottom) {
    border: none;
}
.content table td {
    border: none;
}
</style>
